import { Button, Col, Input, Row, Space } from "antd";
import { useNavigate } from "react-router-dom";
import List from "./List";
import { SearchOutlined } from '@ant-design/icons';

const BasicModule = ({
    headerInfo,
    columnTable,
    dataList,
    deleteHandle,
    rowSelection,
    actionSelection,
    expandableTable,
    setKeySearch,
    selectedRows,
    handleChangeTable
}) => {
    let title = "";
    let description = "";
    if (headerInfo) {
        title = headerInfo.title;
        description = headerInfo.description;
    }
    const navigate = useNavigate();

    const onEditEvent = (record) => {
        navigate("./" + record.id)
    }

    const OnCreateNewEvent = () => {
        navigate("./create")
    }

    const onDeleteEvent = (data) => {
        deleteHandle(data)
    }

    const onChangeSearch = (e) => {
        setKeySearch(e.target.value)
    }

    return (<Row>
        <Col xs={24}>
            {/* Header*/}
            <Row>
                <Col xs={24}>
                    {headerInfo ? (
                        <div className="w-full flex justify-between items-center mb-3 mt-1 pl-3">
                            <div>
                                <h3 className="text-lg font-bold text-slate-800">{title}</h3>
                                <p className="text-slate-500">{description}</p>
                            </div>
                            <div className="mr-3">
                                <div className="w-full max-w-sm min-w-[200px] relative">
                                </div>
                            </div>
                        </div>
                    ) : null}
                </Col>
                <Col xs={24}>
                    <div className="w-full flex justify-between items-center mb-3 mt-1 pl-3">
                        <Button type="primary" onClick={OnCreateNewEvent}>Create New</Button>
                        {setKeySearch ? <Input
                            className="w-64 mr-3"
                            onChange={onChangeSearch}
                            placeholder="Search"
                            prefix={<SearchOutlined />}
                        /> : ""}
                    </div>
                    {rowSelection ? <div className="w-full flex items-center mb-3 mt-1 pl-3">
                        Selected: {selectedRows.length} {selectedRows.length > 0 ? "Items" : ""} || <> </>
                        <Space style={{ marginLeft: '10px' }}>
                            {actionSelection.map((action, index) => (
                                <Button
                                    key={index}
                                    style={{ color: action.color, borderColor: action.color, marginRight: '8px' }}
                                    onClick={action.func}
                                >
                                    {action.label}
                                </Button>
                            ))}
                        </Space>
                    </div> : ""}
                </Col>
            </Row>
            {/* List Table Component */}
            <Row>
                <Col xs={24}>
                    <List
                        columnTable={columnTable}
                        dataList={dataList}
                        onEditEvent={onEditEvent}
                        onDeleteEvent={onDeleteEvent}
                        rowSelection={rowSelection}
                        expandableTable={expandableTable}
                        handleChangeTable={handleChangeTable}
                    />
                </Col>
            </Row>
        </Col>
    </Row>)
}

export default BasicModule